import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../../../common/services/api.service';

export interface Benefit {
    id: number;
    name: string;
    description: string;
    imageUrl: string;
    discount: string;
    channel: string;
}

@Injectable({
    providedIn: 'root'
})
export class BenefitService {
    private api = inject(ApiService)
    private basePath = 'beneficios'

    getDailyBenefits(page: number = 1, pageSize: number = 20): Observable<Benefit[]> {
        return this.api.get(this.basePath, `diario?pageNumber=${page}&pageSize=${pageSize}`).pipe(
            map((response: any) => {
                return response.Result.Table.map((item: any) => ({
                    id: item.Id,
                    name: item.Nombre,
                    description: item.Descripcion,
                    imageUrl: item.Imagenes?.[1]?.URL ?? '',
                    discount: item.DescuentoTexto,
                    channel: item.ComercioNombre,
                }));
            })
        );
    }

getAllBenefits(filters: any, page: number = 0, pageSize: number = 20): Observable<any[]> {
    const body = {
        Texto: filters.Texto || '',
        IdRubro: filters.IdRubro || 0,
        IdComercio: filters.IdComercio || 0,
        DescuentoValor: filters.DescuentoValor || 0,
        DescuentoTexto: filters.DescuentoTexto || '',
        AplicaLunes: filters.AplicaLunes || false,
        AplicaMartes: filters.AplicaMartes || false,
        AplicaMiercoles: filters.AplicaMiercoles || false,
        AplicaJueves: filters.AplicaJueves || false,
        AplicaViernes: filters.AplicaViernes || false,
        AplicaSabado: filters.AplicaSabado || false,
        AplicaDomingo: filters.AplicaDomingo || false,
        CurrentLatitud: filters.CurrentLatitud || 0,
        CurrentLongitud: filters.CurrentLongitud || 0,
        MaxDistanciaMetros: filters.MaxDistanciaMetros || 0,
        IncluirSucursales: true,
        IncluirRubroTracking: true,
        IncluirRubrosBusqueda: false
    };

    return this.api.post(this.basePath, `?pageNumber=${page}&pageSize=${pageSize}`, body).pipe(
        map((res: any) => res?.Result?.Table || [])
    );
}


    getBenefitsByCategory(categoryId: number, page: number = 0, pageSize: number = 20): Observable<any[]> {
        const body = {
            Texto: '',
            IdRubro: categoryId,
            IdComercio: 0,
            DescuentoValor: 0,
            DescuentoTexto: '',
            AplicaLunes: false,
            AplicaMartes: false,
            AplicaMiercoles: false,
            AplicaJueves: false,
            AplicaViernes: false,
            AplicaSabado: false,
            AplicaDomingo: false,
            CurrentLatitud: 0,
            CurrentLongitud: 0,
            MaxDistanciaMetros: 0
        };

        return this.api.post(this.basePath, `?pageNumber=${page}&pageSize=${pageSize}`, body).pipe(
            map((res: any) => res?.Result?.Table || [])
        );
    }


    getBenefitById(id: number): Observable<any> {
        return this.api.get(this.basePath, `${id}`);
    }

    getDynamicBenefits(): Observable<any> {
        const body = {
            CurrentLatitud: NaN,
            CurrentLongitud: NaN,
            MaxDistanciaMetros: 0
        };

        return this.api.post('home/modulos', 'beneficios', body);
    }

}
